import styled from 'styled-components';

export const Container = styled.section`
  user-select: none;
`;
